// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"24068e64","455":"f48fa70d","977":"d2012791"}[chunkId] + ".chunk.js";
};